<comp-dialog>
  <ng-container comp-dialog-header-title>{{ 'revisions.add' | translate }}</ng-container>
  <ng-container comp-dialog-content>
    @if (supportedIntakeTypes(); as intakeTypes) {
      <form id="add-revision-form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <mat-form-field
          appearance="outline"
          [floatLabel]="'always'"
          class="ul-single-line-input outlined-form-element"
        >
          <mat-label>{{ 'model.productRevision.properties.revision' | translate }}</mat-label>
          <input
            [formControlName]="'revision'"
            [errorStateMatcher]="dirtyErrorStateMatcher"
            matInput
            required
            compAutofocus
            (input)="formService.clearError(form, 'revision', 'uniqueness')"
            (blur)="validateUniqueness()"
          />
          @if (form.get('revision')?.hasError('uniqueness')) {
            <mat-error>{{ 'general.validation.uniqueness' | translate }}</mat-error>
          }
          @if (form.get('revision')?.hasError('required')) {
            <mat-error>{{ 'general.validation.required' | translate }}</mat-error>
          }
          @if (form.get('revision')?.hasError('maxlength')) {
            <mat-error>{{
              'general.validation.maxlength'
                | translate: { length: form.get('revision')?.getError('maxlength')?.requiredLength }
            }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="ul-single-line-input outlined-form-element">
          <mat-label>{{ 'model.productRevision.properties.intakeType' | translate }}</mat-label>
          <mat-select panelWidth="auto" [formControlName]="'intakeTypeIdent'" required>
            @for (intakeType of intakeTypes.values(); track intakeType.ident) {
              <mat-option [value]="intakeType.ident" [title]="intakeType.description">
                {{ intakeType.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @let selectedIntakeTypeDescription =
          intakeTypes.get(form.get('intakeTypeIdent')!.value)?.description;
        @if (selectedIntakeTypeDescription !== undefined) {
          <p class="form-field-help-text">
            {{ selectedIntakeTypeDescription }}
          </p>
        }
        <mat-checkbox (change)="onToggleOpenRevision()" [checked]="openRevisionAfterCreation()">{{
          'revisions.open' | translate
        }}</mat-checkbox>
      </form>
    } @else {
      <comp-progress-spinner>{{ 'intake.typesLoading.message' | translate }}</comp-progress-spinner>
    }
  </ng-container>
  <ng-container comp-dialog-footer>
    <comp-card-buttons>
      <ng-container ngProjectAs="[right]">
        <button comp-button="secondary" type="button" (click)="onCancel()">
          {{ 'general.cancel' | translate }}
        </button>
        <button
          comp-button="secondary"
          action="save"
          type="submit"
          form="add-revision-form"
          [disabled]="submitting()"
        >
          {{ 'general.save' | translate }}
        </button>
      </ng-container>
    </comp-card-buttons>
  </ng-container>
</comp-dialog>
